
  document.querySelectorAll('.reveal').forEach(function(el, i){
    setTimeout(function(){ el.classList.add('in'); }, 120 + i * 220);
  });

  /* Slide navigation + firm snapping are handled by CSS scroll-snap (mandatory)
     plus native in-page anchor scrolling — no JS needed. Cue links that point to
     other pages (patent, founder) navigate normally via the shared fade. */

  /* ─── ALL VIDEOS — force autoplay where possible ─── */
  (function(){
    var vids = document.querySelectorAll('video');
    vids.forEach(function(v){
      var attemptPlay = function(){
        var p = v.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function(){
            var unlock = function(){
              v.play().catch(function(){});
              document.removeEventListener('touchstart', unlock);
              document.removeEventListener('click', unlock);
              document.removeEventListener('scroll', unlock);
            };
            document.addEventListener('touchstart', unlock, { passive: true, once: true });
            document.addEventListener('click', unlock, { once: true });
            document.addEventListener('scroll', unlock, { passive: true, once: true });
          });
        }
      };
      if (v.readyState >= 2) {
        attemptPlay();
      } else {
        v.addEventListener('loadeddata', attemptPlay, { once: true });
        v.addEventListener('canplay', attemptPlay, { once: true });
      }
    });
  })();

  /* ─── PROMO RIBBON DISMISS ─── */
  function dismissPromoRibbon(){
    var ribbon = document.getElementById('promoRibbon');
    ribbon.classList.add('dismissed');
    setRibbonCookie('mdv_ribbon_dismissed', '1', 30);
  }

  function setRibbonCookie(name, value, days){
    var d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function getRibbonCookie(name){
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  if (getRibbonCookie('mdv_ribbon_dismissed')){
    document.getElementById('promoRibbon').classList.add('dismissed');
  }

  /* Product card carousel — arrows, dots, touch & mouse swipe, keyboard */
  (function () {
    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      var track = root.querySelector('.carousel-track');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      if (slides.length < 2) return;

      var dotsWrap = root.querySelector('.carousel-dots');
      var prev = root.querySelector('.carousel-arrow.prev');
      var next = root.querySelector('.carousel-arrow.next');
      var index = 0, startX = 0, dx = 0, dragging = false, width = 0;

      var dots = slides.map(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'carousel-dot' + (i === 0 ? ' active' : '');
        b.setAttribute('aria-label', 'Go to photo ' + (i + 1));
        b.addEventListener('click', function () { go(i); });
        if (dotsWrap) dotsWrap.appendChild(b);
        return b;
      });

      function render(animate) {
        track.style.transition = animate ? '' : 'none';
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        dots.forEach(function (d, i) { d.classList.toggle('active', i === index); });
      }
      function go(i) { index = (i + slides.length) % slides.length; render(true); }

      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });

      root.setAttribute('tabindex', '0');
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { go(index - 1); }
        else if (e.key === 'ArrowRight') { go(index + 1); }
      });

      function onMouseMove(e) { move(e.clientX); }
      function onMouseUp() {
        end();
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
      }

      function start(x) {
        dragging = true; startX = x; dx = 0; width = root.clientWidth || 1; track.style.transition = 'none';
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
      }
      function move(x) {
        if (!dragging) return;
        dx = x - startX;
        track.style.transform = 'translateX(calc(' + (-index * 100) + '% + ' + dx + 'px))';
      }
      function end() {
        if (!dragging) return;
        dragging = false;
        if (Math.abs(dx) > width * 0.18) { go(index + (dx < 0 ? 1 : -1)); }
        else render(true);
      }

      root.addEventListener('touchstart', function (e) { start(e.touches[0].clientX); }, { passive: true });
      root.addEventListener('touchmove', function (e) { move(e.touches[0].clientX); }, { passive: true });
      root.addEventListener('touchend', end);
      root.addEventListener('touchcancel', end);

      root.addEventListener('mousedown', function (e) { start(e.clientX); e.preventDefault(); });
    });
  })();

  /* ─── SCROLL-SCRUB HERO ENGINE ───
     Ported from the live Vercel build (maison-dvue.vercel.app) so the hero
     matches it exactly: 300 Full-HD frames on desktop, a lighter 100-frame
     720p set on phones (scroll-scrubbed there too, no looping video), the
     master poster painted first, the narrative beats synced to scroll.
     Frames stream in a sliding window around the scroll position instead of
     all at once, so the page never waits for the whole sequence.
     Frame URLs come from the section (window.MDV_HERO_CFG) so they resolve on
     Shopify's CDN; <img> requests also let the CDN serve WebP, where fetch()
     would be sent JPEGs several times the size. */
  const MDV_HERO_CFG = window.MDV_HERO_CFG || {};

  class MdvHeroCanvasEngine {
    constructor() {
      this.hero = document.getElementById('slide-elixir');
      this.sticky = document.getElementById('heroSticky');
      this.canvas = document.getElementById('heroCanvas');
      this.video = document.getElementById('heroMobileVideo');
      this.poster = document.getElementById('heroStaticPoster');
      this.fill = document.getElementById('hero-loader-fill');
      this.percentEl = document.getElementById('hero-loader-percent');
      this.beatEls = Array.from(document.querySelectorAll('.dv-hero-beat'));

      const ua = navigator.userAgent || '';
      const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      const narrow = window.innerWidth <= 820;
      this.isMobile = /Android|iPhone|iPod|Mobile/i.test(ua) || (isTouch && narrow);
      this.isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const base = MDV_HERO_CFG.frameBase || '';
      this.heroSet = this.isMobile
        ? { count: MDV_HERO_CFG.mobileFrames || 100, prefix: 'mdv-hm-' }
        : { count: MDV_HERO_CFG.desktopFrames || 300, prefix: 'mdv-hd-' };
      this.TOTAL_FRAMES = this.heroSet.count;
      this.images = new Array(this.TOTAL_FRAMES + 1);
      this.frameSrc = (n) => base + this.heroSet.prefix + String(n).padStart(4, '0') + '.webp';
      this.ctx = this.canvas ? this.canvas.getContext('2d', { alpha: false, desynchronized: true }) : null;

      this.currentFrame = 1;
      this.lastDrawnFrame = -1;
      this.scrollDir = 1;
      this.ticking = false;
      this.destroyed = false;
      this.lenis = null;
      this.heroVisible = true;
      this.renderTick = this.renderTick.bind(this);
    }

    init() {
      if (this.isReducedMotion) {
        this.showStaticPoster();
        mdvHeroLoaderDone();
        return;
      }
      if (!this.canvas || !this.ctx) {
        this.showMobileVideo();
        return;
      }
      this.mountCanvas();
      this.initScrollEngine();
      this.initLenis();
      this.preloadRunwayAndStream();
    }

    showStaticPoster() {
      if (this.canvas) this.canvas.style.display = 'none';
      if (this.video) this.video.style.display = 'none';
      if (this.poster) this.poster.style.display = 'block';
    }

    // Only when canvas is unavailable: the poster holds the frame until the
    // video's first frame arrives, instead of a black box.
    showMobileVideo() {
      if (this.canvas) this.canvas.style.display = 'none';
      if (this.poster) this.poster.style.display = 'none';
      mdvHeroLoaderDone();
      if (!this.video) return;
      if (this.poster && this.poster.src) this.video.poster = this.poster.src;
      this.video.src = MDV_HERO_CFG.mobileVideo || '';
      this.video.style.display = 'block';
      this.video.play().catch(() => {});
    }

    mountCanvas() {
      this.canvas.style.willChange = 'transform';
      this.canvas.style.transform = 'translateZ(0)';
      this.canvas.style.backfaceVisibility = 'hidden';
      this.updateCanvasDimensions();
      window.addEventListener('resize', () => this.updateCanvasDimensions(), { passive: true });
    }

    updateCanvasDimensions() {
      const cssWidth = window.innerWidth;
      const cssHeight = window.innerHeight;
      if (cssWidth <= 0 || cssHeight <= 0) return;
      // DPR capped at 1.5 and width at 1920: sharp on Retina, fast to fill.
      const dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      const maxW = 1920;
      let targetW = Math.round(cssWidth * dpr);
      let targetH = Math.round(cssHeight * dpr);
      if (targetW > maxW) {
        targetH = Math.round(targetH * (maxW / targetW));
        targetW = maxW;
      }
      if (this.canvas.width !== targetW || this.canvas.height !== targetH) {
        this.canvas.width = targetW;
        this.canvas.height = targetH;
      }
      this.targetW = targetW;
      this.targetH = targetH;
      const canvasAspect = targetW / targetH;
      const imgAspect = 16 / 9;
      if (canvasAspect > imgAspect) {
        this.drawW = targetW;
        this.drawH = Math.round(targetW / imgAspect);
        this.offsetX = 0;
        this.offsetY = Math.round((targetH - this.drawH) / 2);
      } else {
        this.drawH = targetH;
        this.drawW = Math.round(targetH * imgAspect);
        this.offsetX = Math.round((targetW - this.drawW) / 2);
        this.offsetY = 0;
      }
      this.ctx.imageSmoothingEnabled = true;
      this.ctx.imageSmoothingQuality = 'high';
      if (this.lastDrawnFrame > 0) this.drawSingleFrame(this.lastDrawnFrame);
    }

    preloadRunwayAndStream() {
      let ready = false;
      const releaseScroll = () => {
        if (ready || this.destroyed) return;
        ready = true;
        mdvHeroLoaderDone();
        if (this.lenis) this.lenis.start();
        this.renderTick();
        // Calm sliding window: keep the next ~35 frames ahead of the scroll loaded.
        const streamAhead = () => {
          if (this.destroyed) return;
          if (this.heroVisible) {
            const center = Math.round(this.currentFrame || 1);
            const ahead = Math.min(this.TOTAL_FRAMES, center + 35);
            for (let f = center; f <= ahead; f++) {
              if (!this.images[f]) { this.loadFrame(f, 'low'); break; }
            }
          }
          setTimeout(streamAhead, 50);
        };
        setTimeout(streamAhead, 250);
      };

      const gateSafety = setTimeout(releaseScroll, 800);

      this.posterImg = new Image();
      if ('fetchPriority' in this.posterImg) this.posterImg.fetchPriority = 'high';
      this.posterImg.onload = () => { if (this.lastDrawnFrame <= 2) this.drawPoster(); };
      this.posterImg.src = MDV_HERO_CFG.poster || '';

      this.loadFrame = (idx, priority) => {
        if (this.destroyed || this.images[idx]) return Promise.resolve(this.images[idx]);
        if (this.images[idx] === false) return Promise.resolve(null);
        this.images[idx] = false; // in flight
        return new Promise((resolve) => {
          const img = new Image();
          if (priority === 'high' && 'fetchPriority' in img) img.fetchPriority = 'high';
          img.decoding = 'async';
          img.onload = () => {
            this.images[idx] = img;
            if (idx === 1 && this.lastDrawnFrame <= 2) this.drawSingleFrame(1);
            resolve(img);
          };
          img.onerror = () => { this.images[idx] = undefined; resolve(null); };
          img.src = this.frameSrc(idx);
        });
      };

      try {
        if (this.lenis) this.lenis.stop();
        const RUNWAY = 15;
        let loaded = 0;
        for (let i = 1; i <= RUNWAY; i++) {
          this.loadFrame(i, 'high').then(() => {
            loaded++;
            mdvHeroLoaderProgress(loaded / RUNWAY);
            if (loaded >= RUNWAY && !ready) {
              clearTimeout(gateSafety);
              releaseScroll();
            }
          });
        }
      } catch (e) {
        releaseScroll();
      }
    }

    fetchUrgentFrameChunk(targetFrame) {
      if (this.destroyed || !this.loadFrame) return;
      const dir = this.scrollDir || 1;
      const lo = dir > 0 ? targetFrame - 6 : targetFrame - 16;
      const hi = dir > 0 ? targetFrame + 16 : targetFrame + 6;
      for (let f = Math.max(1, lo); f <= Math.min(this.TOTAL_FRAMES, hi); f++) {
        if (this.images[f] === undefined) this.loadFrame(f, 'high');
      }
    }

    posterReady() {
      return !!(this.posterImg && this.posterImg.complete && this.posterImg.naturalWidth);
    }

    drawPoster() {
      if (!this.ctx || !this.posterReady() || !this.targetW) return;
      this.ctx.drawImage(this.posterImg, this.offsetX, this.offsetY, this.drawW, this.drawH);
    }

    drawSingleFrame(frameNum) {
      if (!this.ctx || !this.targetW) return;
      if (frameNum <= 2 && this.posterReady()) {
        this.drawPoster();
        this.lastDrawnFrame = frameNum;
        return;
      }
      const idx = Math.max(1, Math.min(this.TOTAL_FRAMES, frameNum));
      const ok = (im) => im && im.complete && im.naturalWidth;
      let img = this.images[idx];
      if (!ok(img)) {
        // Nearest loaded frame within ±18, so a fast scroll never flashes black.
        img = null;
        for (let d = 1; d <= 18 && !img; d++) {
          if (ok(this.images[idx - d])) img = this.images[idx - d];
          else if (ok(this.images[idx + d])) img = this.images[idx + d];
        }
        if (!img) { if (this.posterReady()) this.drawPoster(); return; }
        this.ctx.drawImage(img, this.offsetX, this.offsetY, this.drawW, this.drawH);
        return;
      }
      this.ctx.drawImage(img, this.offsetX, this.offsetY, this.drawW, this.drawH);
      this.lastDrawnFrame = frameNum;
    }

    renderTick(y) {
      this.scrollY = (y !== undefined && y !== null) ? y : window.scrollY;
      if (!this.heroVisible) return;
      if (!this.ticking) {
        this.ticking = true;
        requestAnimationFrame(this._performRender || (() => { this.ticking = false; }));
      }
    }

    initLenis() {
      if (typeof Lenis === 'undefined') return;
      this.lenis = new Lenis({
        duration: 1.15,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        orientation: 'vertical',
        gestureOrientation: 'vertical',
        smoothWheel: true,
        wheelMultiplier: 0.88,
        touchMultiplier: 1.0,
        infinite: false
      });
      const raf = (time) => {
        if (this.destroyed) return;
        this.lenis.raf(time);
        requestAnimationFrame(raf);
      };
      requestAnimationFrame(raf);
      this.lenis.on('scroll', (e) => this.renderTick(e ? e.scroll : window.scrollY));
    }

    initScrollEngine() {
      this.measureLayout = () => {
        const vh = window.innerHeight;
        const heroH = this.hero ? this.hero.offsetHeight : 0;
        const heroTop = this.hero ? (this.hero.getBoundingClientRect().top + window.scrollY) : 0;
        this.m = { vh, heroTop, heroScrollable: heroH - vh };
      };
      this.measureLayout();
      window.addEventListener('resize', this.measureLayout, { passive: true });
      [300, 1000, 2500].forEach((ms) => setTimeout(this.measureLayout, ms));

      if ('IntersectionObserver' in window && this.hero) {
        new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.heroVisible = entry.isIntersecting;
            if (this.heroVisible) this.renderTick();
          });
        }, { rootMargin: '100px 0px' }).observe(this.hero);
      }

      this.getScrollProgress = () => {
        const m = this.m;
        if (!m || m.heroScrollable <= 0) return 0;
        const raw = (this.scrollY - m.heroTop) / m.heroScrollable;
        return Math.max(0, Math.min(1, raw || 0));
      };

      this._performRender = () => {
        this.ticking = false;
        if (!this.heroVisible) return;
        const p = this.getScrollProgress();
        const target = Math.max(1, Math.min(this.TOTAL_FRAMES, Math.round(p * (this.TOTAL_FRAMES - 1)) + 1));
        this.scrollDir = target >= this.currentFrame ? 1 : -1;
        this.currentFrame = target;
        this.fetchUrgentFrameChunk(target);
        this.drawSingleFrame(target);
        this.syncBeats(p);
      };

      // Native scroll always drives the frames too. Lenis only reports its own
      // smoothed wheel scrolling; touch scrolling on phones is left native and
      // never reaches its 'scroll' event, which froze the hero on frame 1 there.
      // renderTick is rAF-throttled, so both sources together cost nothing.
      window.addEventListener('scroll', () => this.renderTick(window.scrollY), { passive: true });
      window.addEventListener('touchmove', () => this.renderTick(window.scrollY), { passive: true });
    }

    // The captions set on the section's blocks (data-start/data-end, 0–1).
    syncBeats(p) {
      this.beatEls.forEach((el) => {
        const start = parseFloat(el.dataset.start);
        const end = parseFloat(el.dataset.end);
        el.classList.toggle('is-active', p >= start && p <= end);
      });
    }
  }


  document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById("heroSticky") && !window.heroCanvasEngine) {
      window.heroCanvasEngine = new MdvHeroCanvasEngine();
      window.heroCanvasEngine.init();
    }

    document.querySelectorAll('.wall-sound-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        var video = document.getElementById(btn.getAttribute('data-video-target'));
        if(!video) return;
        video.loop = false;
        video.muted = false;
        video.controls = true;
        video.currentTime = 0;
        video.play();
        btn.closest('.wall-tile--full-review').classList.add('is-playing-full');
      });
    });
  });



/* Loader: the hero engine reports real progress and lifts it when the first
   pass of frames is in. The timer below stays as the safety net — if the hero
   never finishes loading, the loader lifts anyway so the page stays reachable. */
function mdvHeroLoaderProgress(fraction){
  var pct = Math.max(0, Math.min(100, Math.round(fraction * 100)));
  var fill = document.getElementById('hero-loader-fill');
  var label = document.getElementById('hero-loader-percent');
  if (fill) fill.style.width = pct + '%';
  if (label) label.textContent = pct + '%';
}
function mdvHeroLoaderDone(){ window.mdvHeroRelease && window.mdvHeroRelease(); }

(function(){
  var released = false;
  function release(){
    if (released) return;
    released = true;
    mdvHeroLoaderProgress(1);
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    var l = document.getElementById('hero-loader');
    if (l) l.classList.add('loaded');
  }
  window.mdvHeroRelease = release;
  setTimeout(release, 6000);
  window.addEventListener('error', function(e){
    if (e && e.target && (e.target.tagName === 'IMG' || e.target.tagName === 'VIDEO')) release();
  }, true);
})();
